module.exports = __webpack_public_path__ + "static/img/fw1.49da21d.png";


//////////////////
// WEBPACK FOOTER
// ./static/fw1.png
// module id = 8ysR
// module chunks = 1